module.exports = __webpack_public_path__ + "images/fc4c85c120e4ca162d6bc5eeb2d038d0f9300aca852d7bb55bf884b5b79c6df6.svg";